<div [ngSwitch]="action" class="container">
  <ng-template ngSwitchCase="success-eds">
    <svg-icon class="icon" key="certificate-done"></svg-icon>
    <div class="description">
      {{ 'registration.nca.success' | translate }}
      {{ isIndividual ? 'registration.nca.success3' : ('registration.nca.success2' | translate) }}
      {{ 'registration.nca.success4' | translate }}.
      <br />
      {{ 'registration.nca.success5' | translate }}...
    </div>
  </ng-template>

  <ng-template ngSwitchCase="success-sms">
    <svg-icon class="icon" key="phone"></svg-icon>
    <div class="description">
      {{ 'registration.sms.success' | translate }}.
      <br />
      {{ 'registration.nca.success5' | translate }}...
    </div>
  </ng-template>

  <ng-template ngSwitchCase="success-registration">
    <svg-icon class="icon" key="document-done"></svg-icon>
    <div class="description">
      {{ 'registration.success' | translate }}!
      <br />
      {{ 'registration.success2' | translate }}.
    </div>
  </ng-template>

  <div class="loader-body">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </div>
</div>
